import React, { useEffect, useState } from 'react';

import { getCategorys, CategoryType } from 'market/@marketCommon/dataServices/getCategorys';

import { IMarketCategory } from 'market/@marketCommon/interface/category';

import './categoryNavs.scss';

export const CategoryNavs = () => {
    const [categoryList, setCategoryList] = useState<IMarketCategory[]>([]);

    useEffect(() => {
        getCategorys({ type: CategoryType.COURSE }).then((res) => {
            if (!res.error_code) {
                setCategoryList(res.data.list);
            }
        });
    }, []);

    const renderCategorys = () => {
        return categoryList.map((category: IMarketCategory) => {
            return (
                <li key={category.category_id}>
                    <a
                        target="_self"
                        className="item"
                        key={category.category_id}
                        href={`/market/category/${category.category_id}`}
                    >
                        {category.category_name}
                    </a>
                </li>
            );
        });
    };

    const render = () => {
        return (
            <div className="market-category-navs">
                <ul className="options clearfix">{renderCategorys()}</ul>
            </div>
        );
    };

    return render();
};
